export const paths = {
  OVERVIEW: '',
}

export const c2cLinks = {
  c2cLink: (): string => paths.OVERVIEW,
}

export type C2CLinks = typeof c2cLinks
